import createAxios from '../axiosHttp';

function getQueues(pagination,filters) {
    const axios = createAxios();
    let urlPath = `administration/queue`;
    if (pagination) {
        urlPath += `?page=${pagination.currentPage - 1}&limit=${pagination.rows}`;
    } else {
        urlPath += '?page=0&limit=20';
    }
    urlPath+= getFilters(filters);
    return axios.get(urlPath);
}
function getQueuetById(id, entity){
    const axios = createAxios();
    let urlPath = `administration/queue/${id}?entity=${entity}`;
    return axios.get(urlPath);
}
function requeue(filters){
    const axios = createAxios();
    let urlPath = `administration/queue?`;
    urlPath+= getFilters(filters);
    return axios.put(urlPath);
}
function getFilters(filters){
    let urlPath='';
    if (filters && filters.search) {
        urlPath += `&search=${encodeURIComponent(filters.search)}`;
    }
    if (filters && filters.sort) {
        if(filters.sort.sort){
            urlPath += `&sort=${filters.sort.sort}`;
        }
        if(filters.sort.order){
            urlPath += `&order=${filters.sort.order}`;
        }
    }
    if (filters && filters.queue) {
        urlPath += `&entity=${filters.queue}`;
    }
    if (filters && filters.date.start) {
        urlPath += `&start_date=${filters.date.start}`
    }
    if (filters && filters.date.end) {
        urlPath += `&end_date=${filters.date.end}`
    }
    if (filters && filters.status) {
        urlPath += `&status=${filters.status}`;
    }
    return urlPath
}
export const queueService = { getQueues,getQueuetById,requeue};